import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import OnboardingNavigationPicker from 'Views/Onboarding/Components/HeaderBar/OnboardingNavigationPicker';
import { useOnboardingHeaderContext } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';
import PlannerChat from 'Views/Onboarding/Components/HeaderBar/PlannerChat';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
  },
  facetHeaderBarIcon: {
    alignSelf: 'center',
    width: 35,
    height: 'auto',
  },
  headerBarLeft: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerBarCenter: {
    flex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerBarRight: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  facetHeaderBarTitle: {
    textTransform: 'uppercase',
  },
  onboardingNavigation: {},
  iconHighlight: {
    // Styles for highlight from XD
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 10px #4AA6E0',
  },
});

const DigitalOnboardingHeaderBar = ({
  className,
  classes,
  title,
  clientResource,
}) => {
  const {
    isHeaderThemeDark,
    navIconHighlighted,
    chatIconHighlighted,
  } = useOnboardingHeaderContext();

  return (
    <AppBar
      className={classNames(classes.root, className)}
      position={'static'}
      color={'transparent'}
      elevation={0}
    >
      <div className={classes.headerBarLeft}>
        <OnboardingNavigationPicker
          className={classNames(classes.onboardingNavigation, {
            [classes.iconHighlight]: navIconHighlighted,
          })}
          clientResource={clientResource}
        />
      </div>
      <div className={classes.headerBarCenter}>
        {title ? (
          <Typography
            className={classes.facetHeaderBarTitle}
            color={isHeaderThemeDark ? 'white' : 'primary'}
            variant={'h6'}
            weight={'bold'}
            align={'center'}
            test={'survey-header-title'}
          >
            {title}
          </Typography>
        ) : null
        }
      </div>
      <div className={classes.headerBarRight}>
        <PlannerChat
          clientResource={clientResource}
          ButtonProps={{
            className: classNames({
              [classes.iconHighlight]: chatIconHighlighted,
            }),
          }}
        />
      </div>
    </AppBar>
  );
};

DigitalOnboardingHeaderBar.defaultProps = {
  className: '',
  title: null,
};

DigitalOnboardingHeaderBar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  clientResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(DigitalOnboardingHeaderBar);
